<template>
    <div>
        <van-popup position="bottom" v-model="showPopup" @click-overlay='close' :duration=".1">

            <div class="fxpoplogin">
                <h2>
                    <span>会员登录</span>
                    <i @click="close"></i>
                </h2>
                <div class="fxpoplogin-con">
                        <div class="item">
                            <i class="user"/>
                            <input class="put" type="text" name="name" ref="refacc" v-model="account" placeholder="账号" autocomplete="off"/>
                        </div>
                        <div class="item">
                            <i class="pwd"/>
                            <input class="put" type="password" name="pwd" ref="refpwd" v-model="password" placeholder="密码" autocomplete="off"/>
                        </div>
                        <div class="item">
                            <i class="yzm"/>
                            <input class="put" type="number" name="code" ref="refcode" v-model="code" placeholder="验证码" autocomplete="off"/>
                            <yzcode @getIdentifyCode="valcode" :changeCode="changeCode" class="code"/>
                        </div>
<!--                        <div class="item itempd">-->
<!--                            <label><input class="chk" type="checkbox" id="chkremember">记住密码</label>-->
<!--                        </div>-->
                        <button type="button" @click="toLogin">登录</button>
                        <div class="txt"><span @click="toRegister">立即注册</span></div>
                </div>
            </div>
        </van-popup>


    </div>
</template>

<script>
    import yzcode from './yzcode'
    import {mapGetters} from "vuex";
export default {
    name: "loginpop",
    computed: mapGetters(['showlogin']),
    components: {
        yzcode
    },
    watch:{
        // 'showlogin'(v){
        //     console.log(v)
        // }
    },
    data(){
        return {
            account: '',
            password: '',
            code: '',
            showPopup: true,
            yzm: '',
            changeCode: 0
        }
    },
    activated() {
      // console.log(this.showlogin)
    },
    methods: {
        close: function(){
            this.$store.commit('HIDE_LOGINPOP')
        },
        toRegister(){
            this.close()
            this.$router.push({path: '/register'})
        },
        valcode(data){
            this.yzm = data
        },
        toLogin () {
            // console.log(this.$emit('getIdentifyCode'))
            let that = this
            // return
            if(that.account === ''){
                this.$toast('请输入账号')
                this.$nextTick(() =>{
                    this.$refs.refacc.focus()
                })
                return
            }
            if(that.password === ''){
                this.$toast('请输入密码')
                this.$nextTick(() =>{
                    this.$refs.refpwd.focus()
                })
                return
            }
            if(that.code === ''){
                this.$toast('请输入验证码')
                this.$nextTick(() =>{
                    this.$refs.refcode.focus()
                })
                return
            }
            if(that.code !== that.yzm){
                this.$toast('验证码不正确')
                this.changeCode = Math.random()
                that.code = ''
                this.$nextTick(() =>{
                    this.$refs.refcode.focus()
                })
                return
            }
            that.$post(that.$api.login, {name: that.account, pwd: btoa(that.password)}).then(function (res) {
                // console.log(res)
                if(res.code === 1) {
                    // console.log(res.data.user)
                    // console.log(JSON.stringify(res.data.user))
                    that.$store.commit('LOGIN', res.data.token)
                    that.$store.commit('SET_USER', res.data.user)
                    that.close()
                    that.$toast.success({
                        message: res.msg,
                        forbidClick: true,
                        onClose: function () {
                            //关闭pop
                            // location.reload()
                            // if(that.$route.meta.reload){
                            //     location.reload()
                            // }
                        }
                    })
                }
                else{
                    that.$toast.fail(res.msg)
                    that.changeCode = Math.random()
                    that.code = ''
                }
            })
        },
    }
}
</script>

<style scoped>
</style>
